<template>
  <v-container fluid>
    <div v-if="!isEmailOptInEnabled">
      <h2>Instructions for opt-in by email are not available at this time.</h2>
      <p>Please check back later for updates.</p>
    </div>
    <div v-else>
      <h2>Users may opt-in to the alert service via email.</h2>
      <v-alert icon="mdi-information-outline" type="info" class="mt-3" dense>
        Your opt-in request email must be sent from an email address ending in
        one of the following:
        <code>{{ allowedDomains }}</code>
      </v-alert>
      <ol class="pt-3">
        <li>
          Compose a new email message to:
          <v-tooltip v-model="showCopied" color="success" right>
            <template v-slot:activator="{}">
              <v-btn
                small
                text
                class="px-2"
                color="light-blue"
                @click="copyOptInEmailAddress"
              >
                <strong>{{ optInMailbox }}</strong>
              </v-btn>
            </template>
            <span>
              Copied!
            </span>
          </v-tooltip>
          <br />
          You can <a :href="optInEmailHref">click here</a> to open your email
          editor, if one is set-up on this device.
        </li>
        <li>
          Enter your cell phone number (with area code) in the subject line.<br />
          <small
            >For best results, enter only numbers (avoid dashes, spaces, and
            other punctuation).</small
          >
        </li>
        <li>
          Send the email.
        </li>
      </ol>
      <p class="mt-3">
        Within 30 minutes, you will receive a text message to confirm your
        opt-in status.
      </p>
    </div>
  </v-container>
</template>

<script>
import { getEmailOptInSettings } from "@/store/modules/settings";

export default {
  name: "EmailOptInHelp",
  data: () => ({
    isEmailOptInEnabled: false,
    allowedDomains: "",
    optInMailbox: "",
    showCopied: false,
  }),
  computed: {
    optInEmailHref() {
      const data =
        encodeURIComponent(this.optInMailbox) +
        "?subject=" +
        encodeURIComponent("YOUR PHONE NUMBER HERE") +
        "&body=" +
        encodeURIComponent(
          "Replace the subject line with the mobile phone number you want to receive alerts at. \r\n\r\n" +
          "Include the area code. If your number is not in the U.S.A., include the country code. \r\n" +
          "Use only numbers (no punctuation). \r\n" +
          "After entering your phone number in the subject line, send this email. You should receive a confirmation text message within 30 minutes."
        );
      return `mailto:${data}`;
    },
  },
  mounted() {
    getEmailOptInSettings().then((result) => {
      this.isEmailOptInEnabled = result.enabled;
      this.allowedDomains = result.allowedFromDomains;
      this.optInMailbox = result.optInEmailAddress;
    });
  },
  methods: {
    copyOptInEmailAddress() {
      this.$copyText(this.optInMailbox).then(() => {
        this.showCopied = true;
        setTimeout(() => {
          this.showCopied = false;
        }, 5000);
      });
    },
  },
};
</script>
